import { FeatureToggles } from '@qodana/report/lib/components/App/context'

import { LicensePlan } from '../types/organization'

export type ConfigFile = {
	authorizationUrl: string
	dataApiBaseUrl: string
	marketingFormUrl: string
	isStagingContext?: boolean
	youtrackIssueTemplateUrl?: string
	youtubeUrl?: string
	documentationUrls?: {
		generalDocUrl: string
		ciConfigurationUrls: CiConfigurationUrl[]
	}
	privacyPolicyUrl?: string
	reportParams?: object
	queryErrorAlertType?: QueryErrorAlertType
	suppressedQueryErrors?: string[]
	isCreationOrganizationAvailable?: boolean
	firebaseConfig?: object
	isJetBrainsCookieListen?: boolean
	isQDPolicyMessageEnabled?: boolean
	personalOrganizations?: boolean
	defaultLicensePlan: LicensePlan
	featureToggles: FeatureToggles
}

export type CiConfigurationUrl = {
	url: string
	ciName: string
}

export type QueryErrorAlertType = 'ui' | 'console'

let loaderPromise: Promise<ConfigFile> | undefined

async function fetchConfig(): Promise<ConfigFile> {
	if (!window.qdConfigLoader) {
		throw new Error('qdConfigLoader is undefined')
	}

	try {
		return (await window.qdConfigLoader).json()
	} catch {
		throw new Error('An error occurred in the loading config process!')
	}
}

export function loadConfig(config?: ConfigFile) {
	if (loaderPromise) {
		return loaderPromise
	}

	if (config) {
		loaderPromise = Promise.resolve(config)
		return loaderPromise
	}

	loaderPromise = fetchConfig()
	return loaderPromise
}

async function getConfigProp<TProp extends keyof ConfigFile>(
	propName: TProp,
): Promise<ConfigFile[TProp]> {
	const config = await getLoaderPromiseIfExists()

	return config[propName]
}

export const getDataApiBaseUrl = () => getConfigProp('dataApiBaseUrl')
export const getAuthorizationUrl = () => getConfigProp('authorizationUrl')
export const getMarketingFormUrl = () => getConfigProp('marketingFormUrl')

export async function getLoaderPromiseIfExists(): Promise<ConfigFile> {
	if (!loaderPromise) {
		throw new Error('The application config is not loaded yet')
	}

	return loaderPromise
}
